import { parse } from 'lossless-json';
import { AppConfig } from '../../../core/app.config';
import { BACKGROUND_NETWORK_REQ_OPTIONS } from '../../../core/constants/constants';
import { courier } from '../../../core/services/courier.service';
import { retainSafeNumber } from '../../../core/utils/lossless-json-utils';

const appConfig = new AppConfig();
export const ActivationQueryExecutionerAPI = {
  modelsUrl: appConfig.getModelsURL(),

  getQueryExecutionTaskId(query: string, modelSourceId: any) {
    const params = {
      query: query,
      source_destination_id: modelSourceId
    };

    const requestUrl = `${this.modelsUrl}/execute`;

    return courier.post(requestUrl, BACKGROUND_NETWORK_REQ_OPTIONS, params).then(
      (res: any) => {
        return res.data.task_id;
      });
  },

  getQueryExecutionTaskResponse(taskId: number) {
    const requestUrl = `${this.modelsUrl}/execute/${ taskId }`;

    return courier.get(requestUrl, {
      ...BACKGROUND_NETWORK_REQ_OPTIONS,
      networkOptions: {
        responseType: 'text'
      }
    }).then((res: string) => parse(res, null, retainSafeNumber));
  },

  stopQueryExecution(taskId: number) {
    const requestUrl = `${this.modelsUrl}/execution/${ taskId }`;

    return courier.delete(requestUrl, BACKGROUND_NETWORK_REQ_OPTIONS);
  }
};
